export default {"src":"/_next/static/media/avatar-square.7962fa3a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};